import React, { Component } from 'react';
import axios from 'axios';
import Slide from 'react-reveal/Slide';
import { env } from '../../../../shared/environment';
import StatisticCity from './statistic/StatisticCity';
import StatisticAll from './statistic/StatisticAll';
import StaticTench from './statistic/StaticTench';
import IconSearch from '../../../../components/icon/IconSearch';
import './Dashboard.scss';
import Search from './search/Search';

class Dashboard extends Component {
  baseUrl = env.baseUrl;

  constructor() {
    super();

    this.state = {
      statistic: {},
      dataSearch: '',
    };
    this.onChangeSearchCity = this.onChangeSearchCity.bind(this);
  }

  componentDidMount() {
  

    axios.get(`${this.baseUrl}application/statistic/all`).then((response) => {
      console.log(response.data.payload.applicationsStatistic[0], 'response');
      this.setState({ statistic: response.data.payload });
    });
  }

  formatMoney(amount) {
    const thousands = ' ';

    try {
      const negativeSign = amount < 0 ? '-' : '';

      let i = parseInt((amount = Math.abs(Number(amount) || 0))).toString();
      let j = i.length > 3 ? i.length % 3 : 0;

      return (
        negativeSign +
        (j ? i.substr(0, j) + thousands : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands)
      );
    } catch (e) {
      console.log(e);
    }
  }

  onChangeSearchCity(evt) {
    this.setState({ dataSearch: evt.target.value });

    const value = evt.target.value.trim() === '' ? 'all' : evt.target.value;

    axios
      .get(`${this.baseUrl}application/statistic/${value}`)
      .then((response) => {
        this.setState({ statistic: response.data.payload });
      });
  }

  render() {
    const statistics = (
      <div className="statistic_container">
        <div className="statistic_counts">
          <StatisticAll
            label="Общее количество заявок"
            application={this.state.statistic.total}
          />
          <StaticTench
            label="Количество траншов"
            application={this.state.statistic.trench_count}
          />
        </div>

        <div className="search_div">
          <div className="search_input">
            <div className="search_input_icon">
              <IconSearch />
            </div>
            <input
              value={this.dataSearch}
              onChange={this.onChangeSearchCity}
              className="search_input_field"
              placeholder="Поиск по городам и районам"
              type="text"
            />
          </div>
        </div>
        <div className="statistic_cities">
          {this.state.statistic.applicationsStatistic &&
            this.state.statistic.applicationsStatistic.length > 0 &&
            this.state.statistic.applicationsStatistic.map((data, index) => {
              let color = '';
              switch (data.status) {
                case 'new':
                  color = 'badge-danger';
                  break;
                case 'pending':
                  color = 'badge-warning';
                  break;
                case 'accepted':
                  color = 'badge-success';
                  break;
                case 'approved':
                  color = 'badge-primary';
                  break;
                case 'KK':
                  color = 'badge-info';
                  break;

                default:
                  color = 'badge-secondary';
                  break;
              }

              return (
                <StatisticCity
                  city={data.city}
                  application={data.total}
                  tranch={data.trench_count}
                />
              );
            })}
        </div>
      </div>
    );
    return (
      <div className="row">
        <Slide top cascade>
          {statistics}
        </Slide>
      </div>
    );
  }
}

export default Dashboard;
